import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Screenshot: BleskIcon = forwardRef(function Screenshot(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M7.5 3H5C3.895 3 3 3.895 3 5V7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.5V19C3 20.105 3.895 21 5 21H7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 21H19C20.105 21 21 20.105 21 19V16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 7.5V5C21 3.895 20.105 3 19 3H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3371 11.318C14.0545 12.0354 14.0545 13.1985 13.3371 13.9159C12.6197 14.6333 11.4566 14.6333 10.7392 13.9159C10.0218 13.1985 10.0218 12.0354 10.7392 11.318C11.4566 10.6006 12.6197 10.6006 13.3371 11.318"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.625 10.125V15.75C17.625 16.44 17.065 17 16.375 17H7.625C6.935 17 6.375 16.44 6.375 15.75V10.125C6.375 9.435 6.935 8.875 7.625 8.875H8.875L9.789 7.31C9.901 7.118 10.106 7 10.329 7H13.644C13.863 7 14.066 7.115 14.18 7.303L15.126 8.875H16.376C17.065 8.875 17.625 9.435 17.625 10.125V10.125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
